<app-searchbox *ngIf="showDefaultForm && !isCutContent"></app-searchbox>
<div>
  <div itemscope="itemscope" itemtype="http://schema.org/Service" style="display: none;">
    <meta itemprop="name" content="Book Flights"/>
    <meta itemprop="description" content="Save up to 70% off Business class flights"/>
    <meta itemprop="url" content="https://www.wholesale-flights.com/home.xhtml"/>
  </div>
<section id="breadcrumbs">
  <div class="container">
    <div class="row">
      <ul>
        <li *ngFor="let item of paths;">
          <a *ngIf="item.path" routerLink="{{item.path}}">{{item.name}}</a>
          <i *ngIf="item.path" style="margin-right: 5px;"></i>
          <span *ngIf="!item.path">{{item.name}}</span>
        </li>
      </ul>
    </div>
    <!-- /.row -->

  </div>
  <!-- /.container -->
</section>
<section *ngIf="text" id="page-flights-list"  [innerHtml]="text | safeHtml"  (click)="followRoute($event)"></section>
<app-service *ngIf="type !== 'AIRLINES' && type !== 'AIRLINE' && !isCutContent" [business]="true"></app-service>
<!--  <app-trustpilot-grid *ngIf="type !== 'AIRLINES' && type !== 'AIRLINE' && !isCutContent" ></app-trustpilot-grid>-->
<!-- Page Content Flights -->
<section id="flights" *ngIf="flights && flights.length > 0 && flights[0].children && flights[0].children.length > 0 && type && type !== 'CITY'">
  <div class="container">
    <div *ngIf="type !== 'AIRLINES' && type !== 'AIRLINE'" class="row">
      <div class="col-sm-12" *ngIf="type !== 'COUNTRY'">
        <h2 class="mt-4">Find Cheap International Flight Deals at Wholesale Flights</h2>
      </div>
      <div *ngFor="let flight of flights" class="col-sm-12 flights-list">
        <h3>
          <a *ngIf="(type === 'COUNTRY' || type === 'FLIGHTS') && flight.children && flight.children.length > 0" routerLink="{{buildLink(flight.name, isBusinessLand)}}">{{splitAndCapitalize(flight.name)}} business class flights</a>
          <a *ngIf="type !== 'COUNTRY' && type !== 'FLIGHTS'" routerLink="{{buildLink(flight.name, isBusinessLand)}}">{{splitAndCapitalize(flight.name)}}</a>
        </h3>
        <ul *ngIf="flight.children">
          <li *ngFor="let child of flight.children">
            <a routerLink="{{buildLink(child.name, isBusinessLand)}}">
              <span>{{splitAndCapitalize(child.name)}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- /.row -->
    <div *ngIf="type === 'AIRLINES'" class="row">
      <div class="col-sm-12">
        <h2 class="mt-4">Find Cheap International Flight Deals at Wholesale Flights</h2>
      </div>
      <div class="col-sm-12 flights-list">
        <ul>
          <li *ngFor="let flight of flights">
            <a routerLink="{{buildAirlineLink(flight.name, isBusinessLand)}}">
              <span>{{splitAndCapitalize(flight.name)}}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container -->
</section>
</div>
<app-newsletter-form *ngIf="!isCutContent"></app-newsletter-form>
